import Axios from 'axios'

import {handleError} from '../handleError'

import {CreateTrackingLinkRequest, CreateTrackingLinkResponse} from './types'

import {APIResponse, CreateShortenedUrlLinkResponse} from '../types'

import {
  AIRBRIDGE_API_KEY,
  AIRBRIDGE_TRACKING_LINKS_URL,
} from '../../../constants'

export type Params = CreateTrackingLinkRequest
export type AirbridgeReturn = APIResponse<CreateShortenedUrlLinkResponse>
export interface GetTrackingLink {
  (params: Params): Promise<AirbridgeReturn>
}
const ERROR_PATH = 'airbridge.createTrackingLink()'

export const getTrackingLink: GetTrackingLink = async (params) => {
  try {
    const path = AIRBRIDGE_TRACKING_LINKS_URL

    const response = await Axios.post<CreateTrackingLinkResponse>(
      path,
      params,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AIRBRIDGE_API_KEY}`,
        },
      },
    )

    const {
      data: {
        data: {
          trackingLink: {shortUrl},
        },
      },
    } = response

    return Promise.resolve({data: {shortLink: shortUrl}, result: 'success'})
  } catch (e) {
    let message = ''
    if (e instanceof Error) {
      message = e && e.message ? e.message : e.toString()
    }
    const result = handleError(ERROR_PATH, message, e)
    return Promise.resolve(result)
  }
}
